<div class="container">

  <mat-card>

    <form [formGroup]="roleForm" (ngSubmit)="submit()">

      <mat-card-content>

          <div fxLayout="column">

            <mat-form-field>
              <mat-label>{{ "ROLES.NAME" | translate }}</mat-label>
              <input matInput required formControlName="name">
              <mat-hint>Spaces are not allowed. Input will be converted to lowercase.</mat-hint>
              <mat-error *ngIf="roleForm.controls.name.hasError('required')">
                Role Name is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="roleForm.controls.name.hasError('spaces')">
                Role Name cannot contain <strong>spaces</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ "ROLES.DESCRIPTION" | translate }}</mat-label>
              <input matInput required formControlName="description">
            </mat-form-field>

          </div>

      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">{{ 'COMMON.CANCEL' | translate }}</button>
        <button mat-raised-button color="primary" [disabled]="!roleForm.valid || roleForm.pristine">{{ 'COMMON.SUBMIT' | translate }}</button>
      </mat-card-actions>

    </form>

  </mat-card>

</div>
